import React from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { formatKey } from "../Common/FormatData/FormatData";
import { setLoading } from "../../Redux/LoadingRedux";
import { useDispatch } from "react-redux";
import CustomModal from "../Common/CustomModal/CustomModal";
import ConfirmBox from "../Common/ConfirmBox/Confirmbox";
import styles from "./PaymentDetails.module.scss";
import { useState } from "react";
import SecondarySection from "../ui/SectionHeader/SecondarySection";
import { getValidAccessToken } from "../../Services/oauthServices";

function PaymentDetails({
  planDetails: planDetailsProp,
  quoteDetails,
  embedded = false,
}) {
  const location = useLocation();
 const { t,i18n } = useTranslation();
  const { selectedLanguage } = useSelector((state) => state.loading);
  const isAr = selectedLanguage === "ar" || i18n.language?.startsWith("ar");
  const { planDetails } = location.state || {};

  const [fileName, setFileName] = useState();
  const [isSummaryOpen, setIsSummaryOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState(null);
  const [promoCode, setPromoCode] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [error, setError] = useState(false);
  const [showPromoCodeInput, setShowPromoCodeInput] = useState(false);
  const [showPaymentConfirm, setShowPaymentConfirm] = useState(false);

  const message = t(
    "Please agree to the terms and conditions before proceeding to payment.",
  );

  const dispatch = useDispatch();
  // ✅ Safely extract Redux state with fallbacks
  const DomainReducer = useSelector((state) => state?.DomainReducer || {});
  const partnerDetail = DomainReducer?.partnerDetail || {};
  const partnerConfig = DomainReducer?.partnerConfig || {};
  // const PARTNER_ID = partnerDetail?.PARTNER_ID || "";
  const PARTNER_ID =
    partnerDetail?.PARTNER_ID || sessionStorage.getItem("PARTNER_ID");
  const APP_ID = partnerConfig?.APP_ID || partnerDetail?.APP_ID || "";
  const JOURNEY_ID = partnerConfig?.JOURNEY_ID || partnerDetail?.JOURNEY_ID || "";
  const policyResult = planDetails?.policyResult || {};
  const policy_number = policyResult?.policy_number || "";
  //  const policy_number = "45345345345";

  // ✅ Safe summary details
  const summaryDetails = {
    Basic_Premium: planDetails?.quoteDetails?.amount?.base_price ,
    Policy_Fee: planDetails?.quoteDetails?.amount?.policy_fee ,
    Government_Fee: planDetails?.quoteDetails?.amount?.government_fee ,
    Emergency_Fund_Fee:
      planDetails?.quoteDetails?.amount?.emergency_fund_fee ,
    Emergency_Fee_Visitor_Treatment:
      planDetails?.quoteDetails?.amount.emergency_fee_visitor_treatment,
    Dhamani_Fee: planDetails?.quoteDetails?.amount.dhamani_fee,
    VAT: planDetails?.quoteDetails?.amount?.vat ,
  };

  //Bank Route
  const handleSubmit = async () => {
    if (!isChecked) {
      setError(true);
      return;
    }
    dispatch(setLoading(true));
      let premiumQuotes;
    if (quoteDetails) {
      premiumQuotes = {
        ...quoteDetails,
        paymentStatus: "INITIATED",
        quoteId: localStorage.getItem("LIFE_QUOTE_ID"),
      };
    }
    const token = await getValidAccessToken();
    dispatch(setLoading(true));
    const val = await axios.put(
      `${process.env.REACT_APP_API_URL}/api/v1/life/quotes`,
      premiumQuotes,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    );


    try {
      const response = await axios.post(
        `${process.env.REACT_APP_PAYMENT_API_URL}/v1/payments/payment-links`,
        {
          quoteNo: policy_number,
          amount: planDetails?.quoteDetails?.amount?.total,
          partnerId: PARTNER_ID,
          appId: process.env.REACT_APP_APP_ID,
          journeyId: process.env.REACT_APP_JOURNEY_ID,
        },
        {
          headers: {
            Authorization: `Bearer g4df54d5g4d54df054dfg4f`,
          },
        },
      );

      const paymentUrl = response?.data?.data;

      if (paymentUrl) {
        window.location.href = paymentUrl;
      } else {
        console.error("Payment URL not found in API response.");
      }

    } catch (err) {
      console.error("Error during payment initiation:", err);
      alert("Payment failed. Please try again.");
    } finally {
      dispatch(setLoading(false));
    }
  };

  // Byepass Route
  // const handleSubmit = async () => {
  //   if (!isChecked) {
  //     setError(true);
  //     return;
  //   }
  //   if (!PARTNER_ID || !APP_ID || !JOURNEY_ID) {
  //     console.error("Partner configuration is not ready yet.");
  //     alert("Partner configuration is not ready yet. Please try again in a moment.");
  //     return;
  //   }
  //   dispatch(setLoading(true));
  //     let premiumQuotes;
  //   if (quoteDetails) {
  //     premiumQuotes = {
  //       ...quoteDetails,
  //       paymentStatus: "INITIATED",
  //       quoteId: localStorage.getItem("LIFE_QUOTE_ID"),
  //     };
  //   }
  //   const token = await getValidAccessToken();
  //   dispatch(setLoading(true));
  //   await axios.put(
  //     `${process.env.REACT_APP_API_URL}/api/v1/life/quotes`,
  //     premiumQuotes,
  //     {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     },
  //   );


  //   try {
  //     const response = await axios.post(
  //       // `${process.env.REACT_APP_PAYMENT_API_URL}/v1/payments/payment-links`,
  //       `${process.env.REACT_APP_API_URL}/api/v1/medical/health/issue-policy`,
  //         {
  //           quoteNo: policy_number,
  //           amount: planDetails?.quoteDetails?.amount?.total,
  //           partnerId: PARTNER_ID,
  //           appId: APP_ID,
  //           journeyId: JOURNEY_ID,
  //         },
  //         {
  //           headers: {
  //           Authorization: `Bearer g4df54d5g4d54df054dfg4f`,
  //         },
  //       },
  //     );

  //     // const paymentUrl = response?.data?.data;

  //     // if (paymentUrl) {
  //     //   window.location.href = paymentUrl;
  //     // } else {
  //     //   console.error("Payment URL not found in API response.");
  //     // }
  //     const redirectUrl = response.data.redirectUrl;

  //     if (redirectUrl) {
  //       window.location.href = redirectUrl;
  //     }

  //   } catch (err) {
  //     console.error("Error during payment initiation:", err);
  //     alert("Payment failed. Please try again.");
  //   } finally {
  //     dispatch(setLoading(false));
  //   }
  // };

  const handlePayPremiumClick = () => {
    if (!isChecked) {
      setError(true);
      return;
    }

    setError(false);
    setShowPaymentConfirm(true);
  };

  const handlePreview = async (policy, fileName) => {
    setFileName(fileName);
  };

  return (
    <>
      <div className="col-lg-6 col-md-12">
        <div className="plan-card-plan shadow p-3">
          {!embedded && (
            <div className="row">
              <div className="col-md-12 py-3">
                <h3 className="title pt-2 mb-2">{t(planDetails?.coverPlan)}</h3>
                <h5 className="title subHeader p-0 fw-bold py-1 mb-2">
                  {t("Enter Payment Details")}
                </h5>
              </div>
            </div>
          )}
          <div className={embedded ? "col-md-12" : "col-md-8"}>
            <div className="plan-card-plan mb-3">
              {embedded && (
                <h5 className="title p-0 fw-bold py-1 mb-2">
                  {t("Payment Summary")}
                </h5>
              )}
              <table className="w-100 mb-3">
                <tbody>
                  {Object.entries(summaryDetails).map(([key, value]) => (
                    <tr key={key} className={styles["summary-row"]}>
                      <td
                        className={`fw-bold plan-desc p-2 ${styles["summary-label"]}`}
                      >
                        {t(formatKey(key))}
                      </td>
                      <td
                                              className={`section-label fw-bold ${isAr ? "text-start" : "text-end"} py-1 ${styles["summary-value"]}`}
                      >
                        {value !== null && value !== undefined
                          ? Number(value).toFixed(3)
                          : "—"}
                      </td>
                    </tr>
                  ))}

                  <tr className={styles["summary-row"]}>
                    <td
                      className={`fw-bold plan-desc p-2 ${styles["summary-label"]}`}
                    >
                      {t("Reference Number")}
                    </td>
                    <td
                                           className={`section-label fw-bold ${isAr ? "text-start" : "text-end"} py-1 ${styles["summary-value"]}`}
                     
                    >
                      {planDetails?.policyResult?.policy_number || "—"}
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* <div className="plan-card-plan mb-3 d-flex justify-content-between align-items-center ">

            <div className="plan-info p-2 ps-0">
              <p className="plan-name">
                {t(planDetails?.selectedPlan?.planName)}
              </p>
            </div>
            <div className="plan-action">
              <p className="plan-price">
                <span className="price-amount">
                  {planDetails?.quoteDetails?.amount?.total !== undefined &&
                  planDetails?.quoteDetails?.amount?.total !== null
                    ? Number(planDetails.quoteDetails.amount.total).toFixed(3)
                    : "—"}{" "}
                  OMR
                </span>
              </p>
            </div>
          </div> */}
              <div className="terms-condition mb-1">
                <div className={`form-check m-0 ${isAr ? "form-check-reverse" : ""}`}>
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={isChecked}
                    onChange={(e) => setIsChecked(e.target.checked)}
                  />
                  <label className="form-check-label">
                    {t("I agree to the")}
                    &nbsp;
                  </label>
                  <label className="form-check-label">
                    <a
                      className="link-color"
                      href="https://dhofarinsurance.com/privacy-policy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t(" Privacy Policy")}
                    </a>
                  </label>
                </div>
              </div>
              {error && !isChecked && (
                <label className="text-danger small">{message}</label>
              )}
              <p
                className={`fw-bold ${isChecked ? "mt-3" : "mt-2"} m-0`}
                role="button"
                tabIndex={0}
                style={{ cursor: "pointer" }}
                onClick={() => setShowPromoCodeInput((prev) => !prev)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    setShowPromoCodeInput((prev) => !prev);
                  }
                }}
              >
                {t("Have any promo code ?")} 
              </p>
              {showPromoCodeInput && (
                <div className="col-12 col-md-8 mb-3">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter Promo Code")}
                      value={promoCode}
                      onChange={(e) => setPromoCode(e.target.value)}
                    />
                    <button type="button" className="btn btn-outline-primary">
                      {t("Apply Promo Code")}
                    </button>
                  </div>
                </div>
              )}
              {/* <div className="col-12 col-md-6">
            <button
              type="button"
              className="btn btn-primary py-2 px-4"
              onClick={() => handleSubmit()}
              // disabled={!canProceed}
            >
              {t("Proceed to Payment")}
            </button>
          </div> */}
            </div>
          </div>
          <CustomModal
            isOpen={isSummaryOpen}
            onClose={() => {
              setIsSummaryOpen(false);
              if (selectedPdf) {
                URL.revokeObjectURL(selectedPdf);
                setSelectedPdf(null);
              }
            }}
            title={fileName}
            download={true}
            pdfUrl={selectedPdf}
          >
            <div
              className="modal-body"
              style={{ overflow: "hidden", padding: 0, height: "70vh" }}
            >
              {selectedPdf && (
                <iframe
                  title="View Document"
                  src={`${selectedPdf}#page=1&toolbar=0`}
                  width="100%"
                  height="95%"
                  style={{ border: "none" }}
                />
              )}
            </div>
          </CustomModal>
        </div>
        <SecondarySection className="plan-padding mt-3">
          <div className="row d-flex align-items-center ms-1 me-1">
            <div className={`col-md-7`}>
              <label className={styles["net-premium-label"]}>
                {t("NET PREMIUM")}
              </label>
              <br />

              <label className={styles["pay-cost"]}>
                OMR{" "}
                {planDetails?.quoteDetails?.amount?.total !== undefined &&
                planDetails?.quoteDetails?.amount?.total !== null
                  ? Number(planDetails.quoteDetails.amount.total).toFixed(3)
                  : "—"}{" "}
              </label>
            </div>
             <div className={`col-md-5 ${isAr ? "text-start" : "text-end"}`}>
              <button
                type="button"
                className="btn btn-primary-border py-2 px-4"
                label="PAY PREMIUM"
                onClick={handlePayPremiumClick}
                // disabled={!isChecked}
              >
                {t("PAY PREMIUM")}
              </button>
            </div>
          </div>
        </SecondarySection>
        <ConfirmBox
          show={showPaymentConfirm}
          title={t("Confirm Payment")}
          message={t("Do you want to proceed with premium payment?")}
          showIcon={false}
          confirmText={t("Proceed")}
          cancelText={t("Close")}
          showConfirmButton={true}
          onConfirm={() => {
            setShowPaymentConfirm(false);
            handleSubmit();
          }}
          onClose={() => setShowPaymentConfirm(false)}
        />
      </div>
    </>
  );
}

export default PaymentDetails;
